const listColumn = {
  TICKER: 'stockScreenerItem.ticker',
  PRICE: 'priceInfo.matchPrice',
  ISA3: 'financial.isa3',
  ISA20: 'financial.isa20',
  NET_PROFIT_GROWTH: 'financial.rtq83',
  EBIT_MARGIN: 'financial.rtq27',
  RTD14: 'financial.rtd14',
  RTD7: 'financial.rtd7',
  HIGH_PRICE: 'priceInfo.ceilingPrice',
  LOW_PRICE: 'priceInfo.floorPrice',
  REF_PRICE: 'priceInfo.referencePrice',
  CHANGE_PRICE: 'priceInfo.priceChange',
};

const listHideColumn = [
  'priceInfo.ceilingPrice',
  'priceInfo.floorPrice',
  'priceInfo.referencePrice',
  'priceInfo.priceChange',
];

export default {
  listColumn,
  listHideColumn,
};
